import { Injectable } from '@angular/core';

import { Action, select, Store } from '@ngrx/store';

import * as fromUsers from './users.reducer';
import * as UsersSelectors from './users.selectors';
import { UserFilters } from './users.reducer';

@Injectable()
export class UsersFacade {
  loaded$ = this.store.pipe(select(UsersSelectors.getUsersLoaded));
  allUsers$ = this.store.pipe(select(UsersSelectors.getAllUsers));
  archivedUsers$ = this.store.pipe(select(UsersSelectors.getAllArchivedUsers));
  error$ = this.store.pipe(select(UsersSelectors.getUsersError));
  selectedUsers$ = this.store.pipe(select(UsersSelectors.getSelected));
  createUserIdentified$ = this.store.pipe(
    select(UsersSelectors.findUserAccount)
  );
  paginatedData$ = this.store.pipe(select(UsersSelectors.getPagination));

  constructor(private store: Store) {}

  dispatch(action: Action) {
    this.store.dispatch(action);
  }
}
